import React from 'preact';

export default function FontFamily() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19.27 19.29">
      <g id="crop 1" clip-path="url(#clip0_250_32595)">
        <g id="Layer_1-2">
          <path id="Vector" d="M2.5 3.40991H0.15C0.0671573 3.40991 0 3.47707 0 3.55991V4.85991C0 4.94275 0.0671573 5.00991 0.15 5.00991H2.5C2.58284 5.00991 2.65 4.94275 2.65 4.85991V3.55991C2.65 3.47707 2.58284 3.40991 2.5 3.40991Z" />
          <path id="Vector_2" d="M15.73 16.6399H14.43C14.3472 16.6399 14.28 16.7071 14.28 16.7899V19.1399C14.28 19.2227 14.3472 19.2899 14.43 19.2899H15.73C15.8129 19.2899 15.88 19.2227 15.88 19.1399V16.7899C15.88 16.7071 15.8129 16.6399 15.73 16.6399Z" />
          <path id="Vector_3" d="M14.43 13.5099H15.73C15.81 13.5099 15.88 13.4399 15.88 13.3599V3.55991C15.88 3.47991 15.81 3.40991 15.73 3.40991H5.93003C5.85003 3.40991 5.78003 3.47991 5.78003 3.55991V4.85991C5.78003 4.93991 5.85003 5.00991 5.93003 5.00991H14.28V13.3599C14.28 13.4399 14.35 13.5099 14.43 13.5099Z" />
          <path id="Vector_4" d="M5.00991 14.28V0.15C5.00991 0.07 4.93991 0 4.85991 0H3.55991C3.47991 0 3.40991 0.07 3.40991 0.15V15.72C3.40991 15.8 3.47991 15.87 3.55991 15.87H19.1099C19.1899 15.87 19.2599 15.8 19.2599 15.72V14.42C19.2599 14.34 19.1899 14.27 19.1099 14.27H5.00991V14.28Z" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_250_32595">
          <rect width="19.27" height="19.29" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}